/**
 * @description 公式所有符号
 */
const DefaultLaTexButton = {
  'zero': {latex: '0', moveto: 1, movefor: 1, tab: 'common', icon: '0',name: '0', title: '0'},
  'one': {latex: '1', moveto: 1, movefor: 1, tab: 'common', icon: '1',name: '1', title: '1'},
  'two': {latex: '2', moveto: 1, movefor: 1, tab: 'common', icon: '2',name: '2', title: '2',},
  'three': {latex: '3', moveto: 1, movefor: 1, tab: 'common', icon: '3', name: '3', title: '3'},
  'four': {latex: '4', moveto: 1, movefor: 1, tab: 'common', icon: '4',name: '4', title: '4'},
  'five': {latex: '5', moveto: 1, movefor: 1, tab: 'common', icon: '5',name: '5', title: '5'},
  'six': {latex: '6', moveto: 1, movefor: 1, tab: 'common', icon: '6',name: '6', title: '6'},
  'seven': {latex: '7', moveto: 1, movefor: 1, tab: 'common', icon: '7',name: '7', title: '7'},
  'eight': {latex: '8', moveto: 1, movefor: 1, tab: 'common', icon: '8',name: '8', title: '8'},
  'nine': {latex: '9', moveto: 1, movefor: 1, tab: 'common', icon: '9',name: '9', title: '9'},

  'alpha': {latex: '\\alpha', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'alpha',name: 'α', title: 'α'},
  'beta': {latex: '\\beta', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'beta',name: 'β', title: 'β'},
  'gamma': {latex: '\\gamma', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'gamma',name: 'γ', title: 'γ'},
  'theta': {latex: '\\theta', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'theta',name: 'θ', title: 'θ'},
  'pi': {latex: '\\pi', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'pi',name: 'π', title: 'π'},
  'delta': {latex: '\\delta', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'delta',name: 'δ', title: 'δ'},
  'phi': {latex: '\\varphi', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'phi',name: 'φ', title: 'φ'},
  'epsilon': {latex: '\\epsilon', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'epsilon',name: 'ε', title: 'ε'},
  'rho': {latex: '\\rho', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'rho',name: 'ρ', title: 'ρ'},
  'omega': {latex: '\\omega', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'omega',name: 'ω', title: 'ω'},
  'Delta': {latex: '\\Delta', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'Delta',name: 'Δ', title: 'Δ'},
  'Omega': {latex: '\\Omega', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'Omega',name: 'Ω', title: 'Ω'},
  'Phi': {latex: '\\Phi', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'Phi',name: 'Φ', title: 'Φ'},
  'mu': {latex: '\\mu', moveto: 1, movefor: 1, tab: 'alphabet', icon: 'mu',name: 'μ', title: 'μ'},

  'equal': {latex: '=', moveto: 1, movefor: 1, tab: 'relation', icon: 'equal',name: '等于', title: '='},
  'ne': {latex: '\\ne', moveto: 1, movefor: 1, tab: 'relation', icon: 'ne',name: '不等于', title: '&ne;'},
  'less_than': {latex: '\\lt', moveto: 1, movefor: 1, tab: 'relation', icon: 'lessthan',name: '小于', title: '&lt;'},
  'greater_than': {latex: '\\gt', moveto: 1, movefor: 1, tab: 'relation', icon: 'greaterthan',name: '大于', title: '&gt;'},
  'greater_equal': {latex: '\\geq', moveto: 1, movefor: 1, tab: 'relation', icon: 'greater_equal', name: '大于等于', title: '&geq;'},
  'less_equal': {latex: '\\leq', moveto: 1, movefor: 1, tab: 'relation',  icon: 'less_equal', name: '小于等于', title: '&leq;'},
  'approx': {latex: '\\approx', moveto: 1, movefor: 1, tab: 'relation', icon: 'approx', name: '约等于', title: '&asymp;'},
  'cong': {latex: '\\cong',  moveto: 1, movefor: 1, tab: 'relation',  icon: 'cong', name: '全等'},
  'sim': {latex: '\\sim',  moveto: 1, movefor: 1, tab: 'relation',  icon: 'sim', name: '相似'},
  'simeq': {latex: '\\simeq',  moveto: 1, movefor: 1, tab: 'relation',  icon: 'simeq', name: '相似'},

  'degree': {latex: '\\^{\\circ}', moveto: 1, movefor: 1, tab: 'geometric', icon: 'degree', name: '度', title: '&deg;'},
  'angle': {latex: '\\angle',  moveto: 1, movefor: 1, tab: 'geometric',  icon: 'angle', name: '角', title: '&ang;'},
  'perpendicular': {latex: '\\perpendicular',  moveto: 1, movefor: 1, tab: 'geometric', icon: 'perpendicular', name: '垂直', title: '&perp;'},
  'parallel_to': { latex: '\\parallel', moveto: 1, movefor: 1, tab: 'geometric', icon: 'parallel', name: '平行', title: '&#8741;'},
  'triangle': {latex: '\\triangle', moveto: 1, movefor: 1, tab: 'geometric', icon: 'triangle', name: '三角', title: '&#9651;'},
  'parallelogram': {latex: '\\parallelogram', moveto: 1, movefor: 1, tab: 'geometric', icon: 'parallelogram', name: '平行四边形', title: '&#9649;'},
  'bigcirc': {latex: '\\bigcirc', moveto: 1, movefor: 1, tab: 'geometric', icon: 'bigcirc', name: '圆', title: '&#9711;'},
  'wideparen': { latex: '\\oversetfrown{}', moveto: 'Left', movefor: 1, tab: 'geometric', icon: 'oversetfrown', name: '弧'},

  'round_brackets': {  latex: '\\left({}\\right)', moveto: 'Left',  movefor: 1, tab: 'brackets', icon: 'round_brackets', name: '小括号'},
  'bracket': { latex: '\\left[{}\\right]', moveto: 'Left', movefor: 1, tab: 'brackets', icon: 'bracket', name: '中括号'},
  'braces': { latex: '\\left\\{ {}\\right\\}', moveto: 'Left', movefor: 1, tab: 'brackets', icon: 'braces', name: '大括号'},
  'modulus': { latex: '\\left| {}\\right|', moveto: 'Left', movefor: 1, tab: 'brackets', icon: 'modulus',  name: '绝对值' },

  'lefttsrightm': {  latex: '\\left({},{}\\right]', moveto: 'Left',  movefor: 2, tab: 'interval', icon: 'lefttsrightm', name: '左开右闭'},
  'lefttmrights': { latex: '\\left[{},{}\\right)', moveto: 'Left', movefor: 2, tab: 'interval', icon: 'lefttmrights', name: '左闭右开'},
  'leftrightm': { latex: '\\left[{},{}\\right]', moveto: 'Left', movefor: 2, tab: 'interval', icon: 'leftrightm', name: '闭区间'},
  'leftrights': { latex: '\\left({},{}\\right)', moveto: 'Left', movefor: 2, tab: 'interval', icon: 'leftrights',  name: '开区间' },

  'in': { latex: '\\in', moveto: 1, movefor: 1, tab: 'set', icon: 'in', name: '属于', title: '&isin;' },
  'notin': { latex: '\\notin', moveto: 1, movefor: 1, tab: 'set', icon: 'notin', name: '不属于', title: '&notin;' },
  'supseteq': { latex: '\\supseteq', moveto: 1, movefor: 1, tab: 'set', icon: 'supseteq' , name: '包含', title: '&supe;' },
  'subseteq': { latex: '\\subseteq', moveto: 1, movefor: 1, tab: 'set', icon: 'subseteq' , name: '包含于', title: '&sube;'},
  'supset': { latex: '\\supset', moveto: 1, movefor: 1, tab: 'set', icon: 'supset' , name: '真包含', title: '&sup;' },
  'subset': { latex: '\\subset', moveto: 1, movefor: 1, tab: 'set', icon: 'subset' , name: '真包含于', title: '&sub;' },
  'cap': { latex: '\\cap', moveto: 1, movefor: 1, tab: 'set', icon: 'cap' , name: '交集', title: '&cap;' },
  'cup': { latex: '\\cup', moveto: 1, movefor: 1, tab: 'set', icon: 'cup' , name: '并集', title: '&cup;' },
  "complement": { latex: 'C_U', moveto: 1, movefor: 1, tab: 'set', icon: 'complement', name: '补集' },
  "complementu": { latex: 'C_{}', moveto: 1, movefor: 1, tab: 'set', icon: 'complementu', name: '补集' },
  "emptyset": { latex: '\\emptyset', moveto: 1, movefor: 1, tab: 'set', icon: 'emptyset', name: '空集', title: '&empty;' },

  'square': { latex: '{}\\^{2}', moveto: 'Left', movefor: 3, tab: 'exponent', icon: 'square', name: '平方'},
  'cube': { latex: '{}\\^{3}', moveto: 'Left', movefor: 3, tab: 'exponent', icon: 'cube', name: '立方'},
  'sup': { latex: '{}\\^{}', moveto: 'Left', movefor: 3, tab: 'exponent', icon: 'exponentn', name: 'n次方'},

  'lg': { latex: '\\lg{}', moveto: 1, movefor: 1, tab: 'logarithm', icon: 'lg' , name: 'lg', title: 'lg'},
  'ln': { latex: '\\ln{}', moveto: 1, movefor: 1, tab: 'logarithm', icon: 'ln' , name: 'ln', title: 'ln'},
  'log': { latex: '\\log_{a}b', moveto: 'Left', movefor: 3, tab: 'logarithm', icon: 'log', name: 'log', title: 'log' },

  'square_root': {latex: '\\sqrt{}', moveto: 'Left', movefor: 1, tab: 'radical', icon: 'sqrt', name: '平方根'},
  'cube_root': {latex: '\\sqrt[3]{}', moveto: 'Left', movefor: 1, tab: 'radical', icon: 'cube_root', name: '立方根'},
  'root': {latex: '\\sqrt[{}]{}', moveto: 'Left', movefor: 2, tab: 'radical', icon: 'root', name: '根号'},

  "equation": { latex: '\\begin{cases}\\end{cases}', moveto: 'Left', movefor: 2, tab: 'equation', icon: 'equation', name: '方程组' },
  "binary_equations": { latex: '\\begin{cases}\\\\\\end{cases}', moveto: 'Left', movefor: 2, tab: 'equation', icon: 'binary_equations', name: '方程组',style: {
    root: {
      'font-size': '15%'
    }
  }},
  "ternary_equations": { latex: '\\begin{cases}\\\\\\\\\\end{cases}', moveto: 'Left', movefor: 2, tab: 'equation', icon: 'ternary_equations', name: '方程组', style: {
    root: {
      'font-size': '5%'
    },
    matrix: {
      'margin-top': '-5px'
    }
  }},
  "quaternion_equations": { latex: '\\begin{cases}\\\\\\\\\\\\\\end{cases}', moveto: 'Left', movefor: 2, tab: 'equation', icon: 'quaternion_equations', name: '方程组', style: {
    root: {
      'font-size': '5%'
    },
    matrix: {
      'margin-top': '-12px'
    }
  }},

  "sin": { latex: "\\sin", moveto: 1, movefor: 4, tab: 'trigonometric', icon: 'sin', title: "sin", name: '正弦' },
  "cos": { latex: "\\cos", moveto: 1, movefor: 4, tab: 'trigonometric', icon: 'cos', title: 'cos', name: '余弦' },
  "tan": { latex: "\\tan", moveto: 1, movefor: 4, tab: 'trigonometric', icon: 'tan', title: 'tan', name: '正切' },
  "cot": { latex: "\\cot", moveto: 1, movefor: 4, tab: 'trigonometric', icon: 'cot', title: 'cot', name: '余切' },
  "sec": { latex: "\\sec", moveto: 1, movefor: 4, tab: 'trigonometric', icon: 'sec', title: 'sec', name: '正割' },
  "csc": { latex: "\\csc", moveto: 1, movefor: 4, tab: 'trigonometric', icon: 'csc', title: 'csc', name: '余割' },

  "serial_one": { latex: '①', moveto: 1, movefor: 1, tab: 'serial', icon: '①', name: '序号', title: '①'},
  "serial_two": { latex: '②', moveto: 1, movefor: 1, tab: 'serial', icon: '②', name: '序号', title: '②'},
  "serial_three": { latex: '③', moveto: 1, movefor: 1, tab: 'serial', icon: '③', name: '序号', title: '③'},
  "serial_four": { latex: '④', moveto: 1, movefor: 1, tab: 'serial', icon: '④', name: '序号', title: '④'},
  "serial_five": { latex: '⑤', moveto: 1, movefor: 1, tab: 'serial', icon: '⑤', name: '序号', title: '⑤'},
  "serial_six": { latex: '⑥', moveto: 1, movefor: 1, tab: 'serial', icon: '⑥', name: '序号', title: '⑥'},
  "serial_seven": { latex: '⑦', moveto: 1, movefor: 1, tab: 'serial', icon: '⑦', name: '序号', title: '⑦'},
  "serial_eight": { latex: '⑧', moveto: 1, movefor: 1, tab: 'serial', icon: '⑧', name: '序号', title: '⑧'},
  "serial_nine": { latex: '⑨', moveto: 1, movefor: 1, tab: 'serial', icon: '⑨', name: '序号', title: '⑨'},

  "centigrade": { latex: '\\^{\\circ}C', moveto: 1, movefor: 1, tab: 'unit', icon: 'centigrade', name: '摄氏度' },
  "fahrenheit": { latex: '\\^{\\circ}F', moveto: 1, movefor: 1, tab: 'unit', icon: 'fahrenheit', name: '华氏度' },

  "toarrow": { latex: "\\to", moveto: 1, movefor: 1, tab: 'chemical', icon: 'to', name: '右箭头', title: '&rarr;' },
  "leftarrow": { latex: "\\leftarrow", moveto: 1, movefor: 1, tab: 'chemical', icon: 'leftarrow', name: '左箭头' , title: '&larr;'},
  "uparrow": { latex: "\\uparrow", moveto: 1, movefor: 1, tab: 'chemical', icon: 'uparrow', name: '上箭头', title: '&uarr;' },
  "downarrow": { latex: "\\downarrow", moveto: 1, movefor: 1, tab: 'chemical', icon: 'downarrow', name: '下箭头', title: '&darr;' },
  "xrightarrow_chemical": { latex: "\\xrightarrow{}{}", moveto: "Left", movefor: 1, tab: 'chemical', icon: 'xrightarrow_chemical', name: '' },
  "xlongequal_chemical": { latex: "\\xlongequal{}{}", moveto: "Left", movefor: 1, tab: 'chemical', icon: 'xlongequal_chemical', name: '' , style: {
    matrix: {
      'transform': 'scale(.9,.9)'
    }
  }},
  "xrightleftharpoons_chemical": { latex: "\\xrightleftharpoons{}{}", moveto: "Left",  movefor: 1, tab: 'chemical', icon: 'xrightleftharpoons_chemical', name: ''},

  "r_superscript": { latex: "{}^{}", moveto: "Left",  movefor: 1, tab: 'script', icon: 'sup', name: '右上标' },
  "r_subscript": { latex: "{}_{}", moveto: "Left",  movefor: 1, tab: 'script', icon: 'r_subscript', name: '右下标' },
  "r_sub_sup": {latex: '{}_{}^{}', moveto: "Left",  movefor: 2, tab: 'script', icon: 'r_subsupscript', name: '右上下角标'},
  "l_superscript": { latex: "^{}{}", moveto: "Left",  movefor: 1, tab: 'script', icon: 'l_sup', name: '左上标' },
  "l_subscript": { latex: "_{}{}", moveto: "Left",  movefor: 1, tab: 'script', icon: 'l_subscript', name: '左下标' },
  "l_sub_sup": {latex: '_{}^{}{}', moveto: "Left",  movefor: 1, tab: 'script', icon: 'l_subsupscript', name: '左上下角标'},

  "plus": { latex: "+", moveto: 1, movefor: 1, tab: 'common', icon: 'plus', name: '加',title: '+'},
  "reduce": { latex: "-",moveto: 1, movefor: 1, tab: 'common', icon: 'reduce', name: '减', title: '-'},
  "multiplication": {latex: "\\times", moveto: 1, movefor: 1, tab: 'common', icon: 'multiplication',  name: '乘', title: '&times;'},
  "division": {latex: "\\div", moveto: 1, movefor: 1, tab: 'common', icon: 'division',  name: '除', title: '&divide;'},
  "cdot": { latex: "\\cdot", moveto: 1, movefor: 1, tab: 'common', icon: 'cdot',  name: '点乘'},
  "xie": { latex: "/", moveto: 1, movefor: 1, tab: 'common', icon: 'xie',  name: '斜线', latexicon: '/'},
  "shuxian": { latex: "|", moveto: 1, movefor: 1, tab: 'common', icon: 'shuxian',  name: '竖线', latexicon: '|'},
  "xinghao": { latex: "*", moveto: 1, movefor: 1, tab: 'common', icon: 'xinghao',  name: '星号', latexicon: '*'},
  "plus_minus": {latex: "\\pm", moveto: 1, movefor: 1, tab: 'common', icon: 'plus_minus',  name: '正负'},
  "fraction": {latex: "\\frac{}{}", moveto: "Up", movefor: 1, tab: 'common', icon: 'frac',name: '分式'},
  'square_common': { latex: '{}\\^{2}', moveto: 'Left', movefor: 3, tab: 'common', icon: 'square', name: '平方'},
  'square_root_common': {latex: '\\sqrt{}', moveto: 'Left', movefor: 1, tab: 'common', icon: 'sqrt', name: '平方根'},
  "r_superscript_common": { latex: "{}\\^{}", moveto: "Left",  movefor: 1, tab: 'common', icon: 'sup', name: '上标' },
  "r_subscript_common": { latex: "{}\\_{}", moveto: "Left",  movefor: 1, tab: 'common', icon: 'r_subscript', name: '下标' },
  "r_sub_supscript_common": { latex: "{}\\^{}_{}", moveto: "Left",  movefor: 1, tab: 'common', icon: 'sub_sup', name: '上下标' },
  "percent": {latex: "%", moveto: 1,  movefor: 1, tab: 'common', icon: 'percent', name: '百分号', title: '%'},
  "dotx": { latex: "\\dot{}", moveto: "Left",  movefor: 1, tab: 'common', icon: 'dotx', name: '循环小数' },
  "infty": { latex: "\\infty", moveto: "Left",  movefor: 1, tab: 'common', icon: 'infty', name: '无穷',title: '&infin;' },
  "dot": { latex: ".", moveto: 1, movefor: 1, tab: 'common', icon: 'dot', name: '小数点', title: '.' },
  "space": {latex: "\\ ", moveto: 1,  movefor: 1, tab: 'common', icon: 'SPACE', name: '空格', title: 'SPACE'},
  "comma": { latex: ",", moveto: 1,  movefor: 1, tab: 'common', icon: 'comma', name: '逗号', title: ',' },
  "compare": { latex: ":", moveto: 1,  movefor: 1, tab: 'common', icon: 'compare', name: '比', title: ':' },
  'pi_common': {latex: '\\pi', moveto: 1, movefor: 1, tab: 'common', icon: 'pi',name: 'π', title: 'π'},
  'modulus_common': { latex: '\\left| {}\\right|', moveto: 'Left', movefor: 1, tab: 'common', icon: 'modulus',  name: '绝对值' },
  "direc_num": {latex: "\\prime", moveto: 1, movefor: 1, tab: 'common', icon: 'direc_num',name: '分',title: '&prime;'},
  "direc_duble_num": {latex: "\\dprime", moveto: 1, movefor: 1, tab: 'common', icon: 'direc_duble_num',name: '秒',title: '&Prime;'},
  "factorial": {latex: '!', moveto: 1, movefor: 1, tab: 'common', icon: 'factorial',name: '阶乘',title: '!'},
  "overline": {latex: "\\overline{}", moveto: 'Left', movefor: 1, tab: 'common', icon: 'overline', name:'向量'},
  "overrightarrow": {latex: "\\overrightarrow{}", moveto: 'Left', movefor: 1, tab: 'common', icon: 'overrightarrow', name:'向量'},
  "overleftrightarrow": {latex: "\\overleftrightarrow{}", moveto: 'Left', movefor: 1, tab: 'common', icon: 'overleftrightarrow', name:'向量'},

  "sum_": {latex: "\\sum^{}_{}",moveto: "Up", movefor: 1, tab: 'common', icon: 'sum',name: '求和'},

  "rome_one": { latex: 'Ⅰ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅰ', name: '罗马数字', title: 'Ⅰ'},
  "rome_two": { latex: 'Ⅱ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅱ', name: '罗马数字', title: 'Ⅱ'},
  "rome_three": { latex: 'Ⅲ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅲ', name: '罗马数字', title: 'Ⅲ'},
  "rome_four": { latex: 'Ⅳ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅳ', name: '罗马数字', title: 'Ⅳ'},
  "rome_five": { latex: 'Ⅴ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅴ', name: '罗马数字', title: 'Ⅴ'},
  "rome_six": { latex: 'Ⅵ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅵ', name: '罗马数字', title: 'Ⅵ'},
  "rome_seven": { latex: 'Ⅶ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅶ', name: '罗马数字', title: 'Ⅶ'},
  "rome_eight": { latex: 'Ⅷ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅷ', name: '罗马数字', title: 'Ⅷ'},
  "rome_nine": { latex: 'Ⅸ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅸ', name: '罗马数字', title: 'Ⅸ'},
  "rome_teen": { latex: 'Ⅹ', moveto: 1, movefor: 1, tab: 'numerals', icon: 'Ⅹ', name: '罗马数字', title: 'Ⅹ'},

  "chinese_or": { latex: '或', moveto: 1, movefor: 1, tab: 'chinese', icon: '或', name: '常用中文', title: '或'},
  "chinese_and": { latex: '和', moveto: 1, movefor: 1, tab: 'chinese', icon: '和', name: '常用中文', title: '和'},
  "chinese_both": { latex: '且', moveto: 1, movefor: 1, tab: 'chinese', icon: '且', name: '常用中文', title: '且'},
};

const KayBoardValue = {
  letters: [
    {
      value: "q",
      type: "write",
      class: "ks",
      display: "q",
      new_line: false,
    },
    {
      value: "w",
      type: "write",
      class: "ks",
      display: "w",
      new_line: false,
    },
    {
      value: "e",
      type: "write",
      class: "ks",
      display: "e",
      new_line: false,
    },
    {
      value: "r",
      type: "write",
      class: "ks",
      display: "r",
      new_line: false,
    },
    {
      value: "t",
      type: "write",
      class: "ks",
      display: "t",
      new_line: false,
    },
    {
      value: "y",
      type: "write",
      class: "ks",
      display: "y",
      new_line: false,
    },
    {
      value: "u",
      type: "write",
      class: "ks",
      display: "u",
      new_line: false,
    },
    {
      value: "i",
      type: "write",
      class: "ks",
      display: "i",
      new_line: false,
    },
    {
      value: "o",
      type: "write",
      class: "ks",
      display: "o",
      new_line: false,
    },
    {
      value: "p",
      type: "write",
      class: "ks",
      display: "p",
      new_line: true,
    },
    {
      value: "CapsLock",
      type: "custom",
      class: "ks long icon",
      display: "&#8673;",
      new_line: false,
    },
    {
      value: "a",
      type: "write",
      class: "ks",
      display: "a",
      new_line: false,
    },
    {
      value: "s",
      type: "write",
      class: "ks",
      display: "s",
      new_line: false,
    },
    {
      value: "d",
      type: "write",
      class: "ks",
      display: "d",
      new_line: false,
    },
    {
      value: "f",
      type: "write",
      class: "ks",
      display: "f",
      new_line: false,
    },
    {
      value: "g",
      type: "write",
      class: "ks",
      display: "g",
      new_line: false,
    },
    {
      value: "h",
      type: "write",
      class: "ks",
      display: "h",
      new_line: false,
    },
    {
      value: "j",
      type: "write",
      class: "ks",
      display: "j",
      new_line: false,
    },
    {
      value: "k",
      type: "write",
      class: "ks",
      display: "k",
      new_line: false,
    },
    {
      value: "l",
      type: "write",
      class: "ks",
      display: "l",
      new_line: true,
    },
    {
      value: "z",
      type: "write",
      class: "ks",
      display: "z",
      new_line: false,
    },
    {
      value: "x",
      type: "write",
      class: "ks",
      display: "x",
      new_line: false,
    },
    {
      value: "c",
      type: "write",
      class: "ks",
      display: "c",
      new_line: false,
    },
    {
      value: "v",
      type: "write",
      class: "ks",
      display: "v",
      new_line: false,
    },
    {
      value: "b",
      type: "write",
      class: "ks",
      display: "b",
      new_line: false,
    },
    {
      value: "n",
      type: "write",
      class: "ks",
      display: "n",
      new_line: false,
    },
    {
      value: "m",
      type: "write",
      class: "ks",
      display: "m",
      new_line: false,
    },
  ],
};
export {DefaultLaTexButton, KayBoardValue};
